"use client";

import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Slider from "react-slick";
import ReactPlayer from "react-player";
import { BsFillPlayCircleFill } from "react-icons/bs";

import Topbanner from "../../components/Reusable/Banner/Topbanner";
import Activitygallery from "../../components/Reusable/Activitygallery/Activitygallery";

import Safety from "../../components/Heighlights/Heighlights";
import SafetyList from "../../components/Heighlights/SafetyList";

import {
    AncorSecoundaryButton,
} from "../../components/Reusable/Buttons/Buttons";

import styles from "../../styles/Pages/RidesAndActivities.module.scss";

export default function RideActivity({
    attraction,
    allAttractions,
}) {
    const [filteredAttraction, setFilteredAttraction] =
        useState(allAttractions);

    const filteredArray = filteredAttraction.filter(
        (item) => item.slug !== attraction.slug
    );

    const activityVideoId = attraction.activityVideo;

    const similarAttractions = filteredArray;

    const settings = {
        infinite: true,
        arrows: true,
        speed: 500,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const Images = attraction.galleryImages;

    const highlights = [
        {
            icon: "/icons/thrill.svg",
            title: "Thrill for Everyone",
            description:
                "Every one of our pilots have a valid license and possesses the knowledge, experience, and expertise required of someone with the skill level of a pilot. This includes having a complete comprehension of the factors that a pilot needs to be aware of in order to ensure the safety of the passengers.",
        },

        {
            icon: "/icons/safety-first.svg",
            title: "Safety First, Thrills Second",
            description:
                "We have more than five years of expertise in the field of helicopter safari, during which time we have provided tourists with genuine and exciting adventures. Because of this, our pilots are highly trained professionals who are equipped with all of the necessary skills and information to ensure the safety of the passengers.",
        },

        {
            icon: "/icons/family-star.svg",
            title: "Unforgettable Adventure",
            description:
                "More than five hundred individuals have been able to experience the thrill of one of our helicopter safaris up to this point. This helicopter safari was built from the ground up to provide the maximum amount of personal attention to each guest and to fulfill their every desire for an exciting trip.",
        },
    ];

    return (
        <>
            {/* Banner */}

            <Topbanner
                title={attraction.title}
                bgImage={attraction.bannerImage}
                target="#firstsec"
            />

            {/* Main Content */}

            <section
                className={`${styles.single_attraction} common_padding`}
                id="firstsec"
            >
                <div className="container">
                    <div className="row justify-content-center">

                        {/* Content */}

                        <div
                            className={`${styles.single_attraction_content} col-md-8 common_title ride_activity_title`}
                        >
                            <h2>{attraction.title}</h2>

                            <p className="m-0">
                                {attraction.longDesc}
                            </p>
                        </div>

                        {/* Video */}

                        {attraction?.activityVideo ? (
                            <div
                                className={`${styles.single_attraction_video} col-md-8`}
                            >
                                <video
                                    width="100%"
                                    height="100%"
                                    controls
                                    loop
                                    autoPlay
                                    muted
                                    title="Go-Karting by Adventure Resort"
                                >
                                    <source
                                        src="/video/go-karting.mp4"
                                        type="video/mp4"
                                    />

                                    <meta
                                        itemProp="uploadDate"
                                        content="2023-12-10"
                                    />

                                    <meta
                                        itemProp="thumbnailUrl"
                                        content="https://www.adventureresortkufri.com/images/activitiesimages/single-attrac-banner.png"
                                    />

                                    <track
                                        src="/path/to/captions.vtt"
                                        kind="subtitles"
                                        srcLang="en"
                                        label="English"
                                    />
                                </video>
                            </div>
                        ) : null}

                        {/* Buy Ticket */}

                        <div
                            className={`${styles.buy_ticket_btn} col-md-12 d-flex justify-content-center mt-4`}
                        >
                            <AncorSecoundaryButton
                                redirectPage="/tickets"
                                className="margin_0_auto"
                                buttonText="BUY TICKETS"
                            />
                        </div>

                    </div>
                </div>
            </section>

            {/* Activity Gallery */}

            <Activitygallery
                key={attraction.slug}
                Images={Images}
                title={attraction.title}
            />

            {/* Similar Attractions - Enable if needed */}

            {/*
            <section className={styles.similar_attraction}>
                <div className="container">

                    <div className="text-center common_title">
                        <h2>Similar Rides & Activities</h2>

                        <Image
                            src="/icons/line.svg"
                            width={120}
                            height={2}
                            alt="Line Icon"
                        />
                    </div>

                    <div className={styles.activities_slider}>

                        <Slider
                            {...settings}
                            className="activity_slider"
                        >

                            {similarAttractions.map((item, index) => (
                                <div
                                    className={`${styles.activity_child} common_title`}
                                    key={index}
                                >
                                    <img
                                        src={item.bgImage}
                                        alt={item.title}
                                    />

                                    <h3>{item.title}</h3>

                                    <p>
                                        {item.description}
                                    </p>

                                    <Link
                                        className="secoundary_btn"
                                        href={`/rides-and-activities/${item.slug}`}
                                    >
                                        View More
                                    </Link>
                                </div>
                            ))}

                        </Slider>

                    </div>
                </div>
            </section>
            */}
        </>
    );
}